import { render, staticRenderFns } from "./InsurerPhoneEmail.vue?vue&type=template&id=5e57ef60"
import script from "./InsurerPhoneEmail.vue?vue&type=script&lang=js"
export * from "./InsurerPhoneEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports